// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("./utils.res.js");

function DeviseSignOut(props) {
  return JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx("input", {
                      className: "bg-transparent border border-transparent text-sm font-normal leader-tight cursor-pointer",
                      type: "submit",
                      value: "Logout"
                    }),
                JsxRuntime.jsx("input", {
                      name: "authenticity_token",
                      type: "hidden",
                      value: Utils$ReactHooksTemplate.csrfToken
                    })
              ],
              className: "",
              action: "/accounts/sign_out",
              method: "post"
            });
}

var make = DeviseSignOut;

exports.make = make;
/* react/jsx-runtime Not a pure module */
